import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

// Leaflet CSS
import 'leaflet/dist/leaflet.css'

createApp(App).use(router).mount('#app')
